/* System defined core library */
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { RoutingService } from '../../../../shared/services/routing.service';
import { SelectedExamDetailService } from '../../../shared/services/selected-exam-detail.service';

/* User defined enums/constants */
import { EligibilityErrorCodeMap, SchedulingErrors } from '../../../../shared/constants/scheduling.constant';
import { LoaderService } from '../../../../shared/services/loader.service';

/* Images */
const prometricImg = require('/Assets/images/prometric_icon.png');

@Component({
  selector: 'invalid-request',
  templateUrl: './invalid-request.component.html',
})
export class InvalidRequestComponent {
  /* Input-Output parameter declarations */
  public prometric = prometricImg;
  public errorMessage: string;
  public errorId: string;

  /* Service subscriptions */
  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private routingService: RoutingService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService,
    private loaderService: LoaderService
  ) {
    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });
  }

  /* Initialize the component & call required methods when component loaded first time. */
  ngOnInit() {
    sessionStorage.setItem('previousUrl', window.location.pathname);
    // TODO: add the return to check is component is valid to load

    this.loaderService.hide();

    if (!!this.selectedExamDetailService.invalidEligibilityRequest && !!EligibilityErrorCodeMap[this.selectedExamDetailService.invalidEligibilityRequest]) {
      this.errorMessage = EligibilityErrorCodeMap[this.selectedExamDetailService.invalidEligibilityRequest];
    } else {
      this.errorMessage = 'invalidRequest.title';
    }

    this.errorId = this.selectedExamDetailService.isSessionLoadError ? SchedulingErrors.LoadStorageError : SchedulingErrors.Default;
  }

  /* Navigate away from proscheduler(to term/prometric site) */
  goToPrometric(): void {
    this.routingService.navigateAwayFromProscheduler();
  }
}
